import { render, staticRenderFns } from "./ModalCopyProject.vue?vue&type=template&id=e5c84aaa&scoped=true&"
import script from "./ModalCopyProject.vue?vue&type=script&lang=js&"
export * from "./ModalCopyProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c84aaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5c84aaa')) {
      api.createRecord('e5c84aaa', component.options)
    } else {
      api.reload('e5c84aaa', component.options)
    }
    module.hot.accept("./ModalCopyProject.vue?vue&type=template&id=e5c84aaa&scoped=true&", function () {
      api.rerender('e5c84aaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Modal/ModalCopyProject.vue"
export default component.exports